import { initialize } from './app'

initialize()
